import React, { useEffect } from "react";
import SplitterImgBox from "../../shared/components/SplitterImgBox";
import PrimaryButton from "../../shared/components/CustomButtons";
import AfterImg from "../../assets/images/afterimg.webp";
import BeforeImg from "../../assets/images/beforeimg.webp";
import {
  whyChooseUs,
  Partners,
  HowItsWork,
  CollaborateProject,
  // TestimonialData,
} from "./HomeContent";
import ServiceCard from "../../shared/components/ServiceCard";
import CustomCard, {
  // TestimonialCard,
} from "../../shared/components/CustomCard";
// import { Carousel } from "primereact/carousel";
// import { Accordion, AccordionTab } from "primereact/accordion";
import Footer from "../../layout/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "../../store/slices/servicesSlice";
import { getImageUrl, slugify } from "../../utils/commonFunctions";
import AfterOne from "../../assets/images/1.png";
import AfterTwo from "../../assets/images/2.png";
import { fetchFAQ } from "../../store/slices/contentSlice";
import FrequentQuestions from "../services/FrequentQuestions";
import OurClients from "../services/OurClients";

export default function Home() {
  const { services } = useSelector((state) => state.service);
  // const { faq } = useSelector((state) => state.content);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchServices());
    dispatch(fetchFAQ());
  }, [dispatch]);

  const RedirectToService = () => {
    navigate("/services"); // Replace with your desired route
  };

  // const responsiveOptions = [
  //   {
  //     breakpoint: "1400px",
  //     numVisible: 3,
  //     numScroll: 1,
  //   },
  //   {
  //     breakpoint: "1199px",
  //     numVisible: 3,
  //     numScroll: 1,
  //   },
  //   {
  //     breakpoint: "767px",
  //     numVisible: 2,
  //     numScroll: 1,
  //   },
  //   {
  //     breakpoint: "575px",
  //     numVisible: 1,
  //     numScroll: 1,
  //   },
  // ];

  // const TestimonialTemplate = (item) => {
  //   return (
  //     <TestimonialCard
  //       src={item.src}
  //       title={item.title}
  //       detail={item.detail}
  //       clientName={item.clientName}
  //       designation={item.designation}
  //     />
  //   );
  // };

  const serviceCards = [
    {
      AfterImg: AfterImg,
      BeforeImg: BeforeImg,
      title: "Virtual Staging",
      detail: "Unlock your property's potential with stunning virtual staging.",
    },
    {
      AfterImg: AfterTwo,
      BeforeImg: AfterOne,
      title: "Virtual Staging",
      detail: "Unlock your property's potential with stunning virtual staging.",
    },
  ];

  return (
    <>
      {/* banner start */}
      <div className="py-7">
        <div className="container">
          <div className="grid align-items-center">
            <div className="col-12 lg:col-7">
              <SplitterImgBox BeforeImg={BeforeImg} AfterImg={AfterImg} label />
            </div>
            <div className="col-12 lg:col-5 p-4">
              <h2 className="heading text-4xl font-semibold">
                Transform Your Space with Virtual Staging & 3D Augmented Reality
              </h2>
              <p className="text-gray-color line-height-2 text-lg font-normal">
                Unlock your property's potential with stunning virtual staging,
                personalized renovations, and AI-driven recommendations.
              </p>
              <PrimaryButton
                label="Get Started"
                extraClassNames="w-auto"
                onClick={RedirectToService}
              />
            </div>
          </div>
        </div>
      </div>
      {/* banner end */}

      {/* service start */}
      <div className="py-7 bg-green">
        <div className="container">
          <h2 className="text-white text-center text-4xl mb-6 rubik">
            Our Services
          </h2>
          <div className="grid bg-white">
            {services?.map((service, index) => (
              <div
                key={index}
                className="col p-6 flex flex-column justify-content-center align-items-center cursor-pointer service-box text-center"
                onClick={() => {
                  service?.serviceType === "3DRENDERS" ? navigate(`/3Dservices/${slugify(service.serviceName)}`) : navigate(`/service/${slugify(service.serviceName)}`)
                  window.scrollTo(0, 0);
                }}
              >
                <img
                  src={getImageUrl(service.iconImage)}
                  alt={service.serviceName}
                  className="mb-3"
                  width={50}
                />
                <h3 className="mt-2 text-lg font-semibold" >
                  {service.serviceName}
                </h3>
              </div>
            ))}
          </div>
          <div className="grid mt-4">
            {serviceCards?.map((card, index) => (
              <ServiceCard
                extraClass="col-12 lg:col-6"
                AfterImg={card.AfterImg}
                BeforeImg={card.BeforeImg}
                title={card.title}
                detail={card.detail}
                style={{ height: "370px" }}
                navigate={navigate}
              />
            ))}
          </div>
        </div>
      </div>
      {/* service end */}

      {/* why choose us */}
      <div className="py-7 bg-light-primary">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            Why Choose RedChilli Service?
          </h2>
          {/* <p className="text-gray-color text-center text-lg">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s
          </p> */}
          <div className="grid bg-white mt-7">
            {whyChooseUs?.map((item, index) => (
              <CustomCard
                key={index}
                extraClass="text-center bg-none lg:col-4 lg:text-left"
                src={item.image}
                title={item.title}
                detail={item.detail}
                width={40}
              />
            ))}
          </div>
        </div>
      </div>
      {/* why choose us end */}
      {/* how its work section */}
      <div className="py-7">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            How does it work?
          </h2>
          {/* <p className="text-gray-color text-center text-lg">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s
          </p> */}
          <div className="grid bg-white mt-7">
            {HowItsWork?.map((item, index) => (
              <div key={index} className="col-12 lg:col-4 ">
                <CustomCard
                  key={index}
                  title={item.title}
                  detail={item.detail}
                  extraClass="border-400 how-its-work border-round-xl border-1"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* how its work end */}

      {/* partner start */}
      <div className="py-7 bg-gray-light">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            Partner with us
          </h2>
          <p className="text-gray-color text-center text-lg">
            Work with us to elevate your brand, simplify delivery, and delight customers.
          </p>
          <div className="grid bg-white mt-7">
            {Partners?.map((item, index) => (
              <CustomCard
                extraClass="col-6 partner-box lg:col-4 text-center"
                src={item.image}
                title={item.title}
                detail={item.detail}
                width={40}
              />
            ))}
          </div>
        </div>
      </div>
      {/* partner end */}

      {/* collaborate section start */}
      <div className="py-7">
        <div className="container">
          <h2 className="heading text-4xl mb-4 rubik">
            Collaborate Seamlessly on Staging Projects
          </h2>
          <p className="text-gray-color text-lg">
            Empower teams to work together in real-time, making your staging
            process faster and more effective.
          </p>
          <div className="grid bg-white mt-7">
            {CollaborateProject?.map((item, index) => (
              <div className="col-12 lg:col-4">
                <CustomCard
                  extraClass=" h-full collaborate-box"
                  key={index}
                  src={item.image}
                  width={40}
                  title={item.title}
                  detail={item.detail}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* collaborate section end */}

      {/* testimonial start */}
      <OurClients />
      {/* <div className="py-8 bg-gray-light">
        <div className="container mb-7">
          <h2 className="heading text-4xl text-center mb-4 rubik">
            What Our Client Says
          </h2>
          //  <p className="text-gray-color text-center text-lg">
          //   Lorem Ipsum is simply dummy text of the printing and typesetting
          //   industry. Lorem Ipsum has been the industry's standard dummy text
          //   ever since the 1500s
          // </p> 
          <div className="grid bg-white mt-7">
            <Carousel
              className="w-full testimonial-container"
              value={TestimonialData}
              numVisible={3}
              numScroll={1}
              responsiveOptions={responsiveOptions}
              itemTemplate={TestimonialTemplate}
              showIndicators={false}
            />
          </div>
        </div>
      </div> */}
      {/* testimonial end */}

      {/* faq start */}
      <FrequentQuestions />
      {/* <div className="pt-3 pb-7 bg-gray-light">
        <div className="container">
          <h2 className="heading text-center mt-0 text-4xl mb-4 rubik">
            Frequently asked questions
          </h2>
          <p className="text-gray-color text-center text-lg mb-7">
            Here are some of the common questions we receive:
          </p>
          <Accordion
            className="w-full lg:w-8 m-auto faq-container"
            activeIndex={0}
            collapseIcon="pi pi-minus"
            expandIcon="pi pi-plus"
          >
            <AccordionTab header="What is virtual staging?">
              <p className="m-0">
                It’s digitally adding furniture to photos of empty rooms.
              </p>
            </AccordionTab>
            <AccordionTab header="How long does it take to deliver?">
              <p className="m-0">
                Orders are typically delivered in 1–3 business days.
              </p>
            </AccordionTab>
            <AccordionTab header="Can I request revisions?">
              <p className="m-0">
                Yes, we offer free revisions to ensure satisfaction.
              </p>
            </AccordionTab>
            <AccordionTab header="What photo formats are accepted?">
              <p className="m-0">
                JPEG and PNG formats are preferred for best quality.
              </p>
            </AccordionTab>
            <AccordionTab header="Do you offer bulk pricing?">
              <p className="m-0">
                Yes—contact us for custom packages for 10+ images.
              </p>
            </AccordionTab>
          </Accordion>
        </div>
      </div> */}
      {/* faq end */}

      {/* footer */}
      <Footer />
    </>
  );
}
